const NAME = "GENERAL_VALUES";

export default NAME;
